import { Button, Table } from "antd";
import axios, { formToJSON } from "axios";
import { AppConstants, CustomHeaderToken, GetWebServiceUrl } from "../utils/constants";
import { useCookies } from "react-cookie";
import NotificationHeader, { SetNotificationWithoutDismiss } from "../utils/notification";
import { useEffect, useState } from "react";

async function fetchData(cache) {
    console.log("fetchData")

    let response = await axios.get(GetWebServiceUrl(AppConstants.ADMIN_LIST), CustomHeaderToken(cache.access_token)).catch(err => {
        console.log("ERR", err)
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })

    return response;
}

async function upgrade(targetID, cache) {
    console.log("upgrade")
    let request = {
        "target_id": targetID,
    }
    let response = await axios.post(GetWebServiceUrl(AppConstants.UPGRADE), request, CustomHeaderToken(cache.access_token)).catch(err => {
        console.log("ERR", err)
        if (err.response === undefined){
            return
        }
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })

    return response;
}

async function downgrade(targetID, cache) {
    console.log("downgrade")
    let request = {
        "target_id": targetID,
    }
    let response = await axios.post(GetWebServiceUrl(AppConstants.DOWNGRADE), request, CustomHeaderToken(cache.access_token)).catch(err => {
        console.log("ERR", err)
        if (err.response === undefined){
            return
        }
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })

    return response;
}

export default function AdminContent() {
    const [cookies, setCookie] = useCookies(['access_token'])
    const [dataSource, setDataSource] = useState([])

    const columns = [
        {
            title: 'ID',
            dataIndex: 'ID',
            key: 'ID',
        },
        {
            title: 'تاریخ ایجاد',
            dataIndex: 'CreatedAt',
            key: 'CreatedAt',
        },
        {
            title: 'نام',
            dataIndex: 'username',
            key: 'uesrname',
        },
        {
            title: 'اکتیو؟',
            dataIndex: 'role',
            key: 'role',
            render: (value, record) => (
                <>
                    <Button onClick={() => { upgrade(record.ID, cookies) }} type="link">فعال سازی</Button>
                    <Button onClick={() => { downgrade(record.ID, cookies) }} type="dashed">غیرفعال سازی</Button>

                </>

            )
        },
    ];

    useEffect(() => {
        let response = fetchData(cookies).then(res => {
            setDataSource(res.data)
        })
    }, [])

    return (
        <>
            <NotificationHeader></NotificationHeader>
            <div>
                <Table dataSource={dataSource} columns={columns} />
            </div>
        </>
    )
}